
import DefaultQuotes from "@/components/objects/public/shared-blocks/quotes/design-variant/Default.vue";
import { datesToHuman } from "@/utils/dates.js";
import { LIST_COLORS } from "@/constants/ui.js";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "Quotes",
  provide: {
    source: 'objQuotes'
  },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    quotes: {
      type: Object
    },
    objectLabel: {
      type: String
    },
    user: {
      type: Object,
      default: () => {}
    },
    palette: {
      type: Object,
    },
  },
  data() {
    return {
      ready: false,
      swiper: null,
      templateValue: null
    }
  },
  computed: {
    myPalette() {
      if (this.palette) {
        const palette = this.$store.state["property_templates"]["consts"].palette;
        if (palette) {
          return palette.filter(el => el.id === this.palette)[0];
        }

        return null;
      }

      const palette = this.$store.state["property_templates"]["consts"].palette;

      if (palette) {
        return palette.filter(el => el.id === 'Pal007')[0];
      }

      return null;
    },
    colors() {
      if (this.myPalette) {
        return [this.myPalette.main_color, ...this.myPalette.colors];
      }
      return LIST_COLORS
    },
    items() {
      return this.quotes.items.map((quote, index) => {

        const data = JSON.parse(JSON.stringify(quote))
        if (data.date?.vfrom) {
          data.dateHumanReadable = datesToHuman({ value: data.date.vfrom }, { value: data.date.vto })
        }
        data.color = this.colors[index % this.colors.length]
        return data
      })
    },
    renderComponent() {
      switch (this.quotes.design) {
      case "custom":
        // return DefaultFacts
      default:
        return DefaultQuotes
      }
    },
    listInfo() {
      return {
        label: this.quotes.label,
        subLabel: this.quotes.sublabel || "",
        icon: this.quotes.icon,
        vistat_object: this.quotes.vistat_object,
        object_label: this.objectLabel,
        id: uuidv4(),
      }
    }
  },
  mounted() {
    const items = this.quotes.items

    if (items.length < 2) {
      this.ready = true
      return
    }

    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      const swiperEl = this.$refs.swiperContainer
      const initSwiper = () => {
        this.ready = true
        return this.$nextTick()
      }


      import('@/plugins/swiper.js')
        .then(({ Swiper, Pagination }) => {
          this.swiper = new Swiper(swiperEl, {
            autoHeight: true,
            preventClicks: false,
            preventClicksPropagation: false,
            touchStartPreventDefault: false,
            pagination: {
              enabled: items.length > 1,
              el: '.quotes-swiper-pagination',
              clickable: true,
              dynamicBullets: true
            },
            init: true,
            modules: [Pagination],
            observer: true,
            observeParents: true,
            on: {
              init: async function (swiper) {
                await initSwiper()
                // swiper.updateAutoHeight(0)
              },
              slideChange(swiper) {
                //swiper.updateAutoHeight(200)
              }
            }
          })
        })

    }
  },

  methods: {
    onTemplateChange(evt) {
      this.templateValue = evt
      if (this.swiper) {
        setTimeout(() => {
          this.swiper.updateAutoHeight()
        }, 500)
      }
    }
  }
}
